import React from 'react';
import KickImage from 'Reuseables/KickImage';

import {
  Button
} from 'reactstrap';

import { CGContainer } from '../CommonGroundPage';

const CommonGroundLogin = ({ onClick }) => (
  <CGContainer
    textTop = "Refresh this page if you have successfully registered / logged in on the website."
    textButton = "LOGIN"
    onClick={onClick}
  />
)
export default CommonGroundLogin;